import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
const FileSaver = require('file-saver');
import { moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { MatRadioChange } from '@angular/material/radio';

@Component({
  selector: 'app-fileManager-documents',
  templateUrl: './fileManager-documents.component.html',
  styleUrls: ['./fileManager-documents.component.scss']
})
export class FileManagerDocumentsComponent implements OnInit {

  responseHolder: any; 
  spinner:boolean=false;
  folderList:any=[];
  requestDetail:any;
  fileMangerFolderId:number=0
  folderName:string="";
  senderName:string=""; 
  ShowSubmitButton: boolean = false;
  ResponseHolderDetails: any;
  formData: FormData = new FormData();
  UploadedFiles:any=[]=[];  
  status:boolean=false;
  type:string="";
  token:any="";
  params:string="";
  decryptedToken: any;
  UploadingFiles :any=[]=[];
  verifiedEmail : string="";  
  participantEmailId: string="";
  SubmitBy: string="";
  @ViewChild('AddEmailForUser') AddEmailForUser: TemplateRef<any>;
  TotalfileSize:number=0;
  UploadedRuntimeFiles:any=[]=[];
  selectedFiles: FileList;
  UploadedNewFiles:any=[]=[];
  @ViewChild('Input') InputFile: ElementRef;
  editfilename = {
    id: 0,
    filename: '',
  };
  formDialog: FormGroup;
  authenticationEmail: string="";
  authenticationMobile: string="";
  isEmailVerified = false;
  otpCode: number;
  verifyToken: number=0;
  organizationId: any;
  databaseId: any;
  userID: any;
  myOfficeID: any;
  showPage:boolean=true;

  constructor(private dialog: MatDialog,private router:Router,private route: ActivatedRoute,
    private formsService:FormsService,private loaderService: LoaderService,private toastr: ToastrService,
    private cdr: ChangeDetectorRef,private statusConstant: StatusConstant,
    private encryptionAlgo: EncryptionService,private reusableClass: ReusableClasses,
    private formBuilder: FormBuilder){ 

    } 

  ngOnInit(): void {
    let group = {};
    this.formDialog = new FormGroup(group);
    this.formDialog.addControl('filename', this.formBuilder.control(''));
    this.getQueryParameter();     
  }

  ngAfterViewInit() {   
    this.verifiedEmail = sessionStorage.getItem('userEmailForCode');
    this.participantEmailId = this.verifiedEmail;
    this.SubmitBy = this.verifiedEmail;
    if (this.verifiedEmail == null) {
     // this.dialog.open(this.AddEmailForUser);
    }
  }

  getQueryParameter() {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      
      this.params=  decodeURIComponent(this.token);
      const decryptedTokenString = this.encryptionAlgo.get(this.reusableClass.encryptionKey, this.params);
      this.decryptedToken = JSON.parse(decryptedTokenString);
      //this.senderName=this.decryptedToken.senderName;
      //this.folderName=this.decryptedToken.folderName;
      this.fileMangerFolderId=this.decryptedToken.FileManagerFolderID;
      this.organizationId = this.decryptedToken.OrganizationID;
      this.databaseId = 1;//this.decryptedToken.DatabaseID;
      this.userID = this.decryptedToken.UserID;
      this.myOfficeID = this.decryptedToken.OfficeID;  
      this.verifyFileManagerFolderUrls();  
  });     
  }

     
  verifyFileManagerFolderUrls(){   
    let reqModel ={
      token:encodeURIComponent(decodeURIComponent(this.token)),  
    }  
    this.loaderService.show();
    this.spinner=true;
    this.formsService.verifyFileManagerFolderUrl(reqModel).subscribe(response=>{
      let responseData = response.data; 
      if(responseData==true){
        this.showPage=true;
        this.loaderService.hide();
        this.spinner=false;
        if (this.verifiedEmail == null) {
          this.verifyToken=0;       
          const dialogRef = this.dialog.open(this.AddEmailForUser, {          
            disableClose: true
          });
          // this.dialog.open(this.AddEmailForUser);
         }
      }else{
        this.showPage=false;
        this.loaderService.hide();
        this.spinner=false;
      }      
    });  
  }


  DownloadFile(doc: any) {
    if(doc.base64){
      FileSaver.saveAs(doc.base64, doc.fileName);
      return;
    }
  //   if(!doc.base64){
  //   this.spinner=true;
  //   this.formsService.getAttachment(doc.documentName, doc.documentPath).subscribe((response) => {
  //   if (response !== undefined) {
  //       const data = 'data:' + response.data.contentType +';base64,' + response.data.base64URL;
  //       FileSaver.saveAs(data, doc.documentName);
  //       this.spinner=false;
  //      }else{
  //       this.spinner=false;
  //      }
  //   });
  //  }  
  }

  UploadFile(event: any, document) {
    if (event.target.files.length > 0) {
      let files = event.target.files;   
      const file = event.target.files[0];

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        var FullPath = files[0].name;
        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];
        var documenttype = documentNameSplit[1];
        var base64String = reader.result;

        var ReqModel = {
          placeholderID:document.placeholderID,
          DocumentFolderID:document.documentFolderID,
          fileName: documentName,
          base64: base64String,
          documentType: documenttype,
          file: files[0]
        };
        this.folderList.find((item) => item.placeholderID == document.placeholderID).documentType = documenttype;
        this.folderList.find((item) => item.placeholderID == document.placeholderID).base64 = base64String;
        this.folderList.find((item) => item.placeholderID == document.placeholderID).fileName = documentName;
        const index = this.UploadedFiles.findIndex(el => el.placeholderID === document.placeholderID);
          if (index >= 0) {
          this.UploadedFiles.splice(index, 1);
         }
        this.UploadedFiles.push(ReqModel);
      };
      this.ShowSubmitButton=true;
      this.cdr.detectChanges();  
    } else {
    }
  }
  

 
  
  
  selectFiles(event) {
    this.UploadedRuntimeFiles=[];
   // this.ShowNextButton = false;
    this.selectedFiles = event.target.files;      
    this.TotalfileSize=0;
    this.UploadedNewFiles;

    // If Allready Uploaded file and checking file size   
    this.UploadedRuntimeFiles =  this.UploadedNewFiles.filter(x => x.action !=3);
    this.UploadedRuntimeFiles =  this.UploadedRuntimeFiles.filter(x => x.pdfToImageStatus==null);
    if(this.selectedFiles.length>10){
      this.toastr.warning('You are only allowed to upload a maximum of 10 files.', '', {
        timeOut: 3000,
      });
      return;
    }
    // if(this.UploadedRuntimeFiles.length>0){
    //   for (let i = 0; i < this.UploadedRuntimeFiles.length; i++) {
    //     // While File Compress and get new file size
    //     if(this.UploadedRuntimeFiles[i].size){
    //       this.TotalfileSize+= this.UploadedRuntimeFiles[i].size;  // get file size
    //     }
    //     // While uploading new file
    //     if(!this.UploadedRuntimeFiles[i].size){
    //         this.TotalfileSize+= this.UploadedRuntimeFiles[i].file.size; // get file size
    //     }      
    //   }
    // }
    //  // For new file uploading and checking file size
    // if(this.selectedFiles.length>0){
    //   for (let i = 0; i < this.selectedFiles.length; i++) {
    //     this.TotalfileSize+= this.selectedFiles[i].size; // get file size
    //   }
    // }  
  
    // const TotalFSize = Math.round((this.TotalfileSize / 1024 / 1024));
   
    // if(TotalFSize > 5){
    //   this.toastr.warning('File too Big, please select a file less than 5MB.', '', {
    //     timeOut: 3000,
    //   });
    //   this.InputFile.nativeElement.value = '';
    //   //this.ShowNextButton = true;
    //   return;
    // }

    for (let i = 0; i < this.selectedFiles.length; i++) {
      var ext = this.selectedFiles[i].name.split('.').pop();   

      if (this.selectedFiles[i].name.split('.')[0].length>120) {
        this.toastr.warning('File name upto 120 characters only supported, please rename file.', '', {
          timeOut: 3000,
        });
        return;
      }
      const file = event.target.files[i];
      
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        var FullPath = this.selectedFiles[i].name;
        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];     
        var documenttype = this.selectedFiles[i].name.split('.').pop();
        var isCompressed=false;
        var dynamicDocumentId=0;
      
        var base64String = reader.result;
        var size= this.getReadableFileSizeString(this.selectedFiles[i].size);

        const checksizeFor1MB = Math.round((this.selectedFiles[i].size / 1024));
         // The size of the file.
        if (checksizeFor1MB >= 1024) {
          isCompressed=true;
          dynamicDocumentId = Math.floor(1000 + Math.random() * 9000);
        }else{
          isCompressed=false;
          dynamicDocumentId=0;
        }
        var ReqModel = {
          id: i + 1,
          fileName: documentName,
          progress: 0,
          base64: base64String,
          documentType: documenttype,
          action:0,
          isDeleted:false,
          projectDocumentID:0,
          file:this.selectedFiles[i],
          Totalsize:size,
          isCompressed:isCompressed,
          dynamicDocumentId:dynamicDocumentId
        };
        this.UploadingFiles.push(ReqModel);        
        this.uploadFilesSimulator(0);
      };
    }
    
  }

  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      index = 0;
      if (index === this.UploadingFiles.length) {
        this.InputFile.nativeElement.value = ''; 
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.UploadingFiles.length > 0) {
            if (this.UploadingFiles[index].progress === 100) {
              clearInterval(progressInterval);
              var id =this.UploadedFiles.length;
              var req = {
                id: id+1,//this.UploadingFiles[index].id+1,
                fileName: this.UploadingFiles[index].fileName,
                base64: this.UploadingFiles[index].base64,
                documentType: this.UploadingFiles[index].documentType,
                action:0,
                isDeleted:false,
                projectDocumentID:0,
                file:this.UploadingFiles[index].file,
                FileManagerID:0,
                FillPlaceHolder:false,
                Totalsize:this.UploadingFiles[index].Totalsize,
                isCompressed:this.UploadingFiles[index].isCompressed,
                dynamicDocumentId:this.UploadingFiles[index].dynamicDocumentId
              };
              this.UploadedFiles.push(req);
              this.UploadingFiles.splice(index, 1);
              this.UploadedNewFiles=this.UploadedFiles;
              this.uploadFilesSimulator(index + 1);
              if(this.UploadingFiles.length==0){
                this.ShowSubmitButton = true;                          
              }
            } else {
              this.UploadingFiles[index].progress += 5;
            }
          }
        }, 100);
      }
    }, 500);
  }

  getReadableFileSizeString(fileSizeInBytes) {
    var i = -1;
    var byteUnits = [' KB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    do {
        fileSizeInBytes = fileSizeInBytes / 1024;
        i++;
    } while (fileSizeInBytes > 1024);

    return Math.max(fileSizeInBytes).toFixed(3) + byteUnits[i];
  };
 

  downloadPdf(file) {
    if(file.FileManagerID > 0){
      //this.DownloadSingleFileManager(file);
      return;
    }
    else if(file.projectDocumentID > 0){
      //this.DownloadSingleFile(file);
      return;
    }
    else if(file.projectDocumentID ==0 && file.FileManagerID!=0){
     FileSaver.saveAs(file.base64, file.fileName);
     return;
    } 
    else if(file.projectDocumentID ==0 && file.FileManagerID==0 && !file.base64){
     // this.DownloadSingleFile(file);
      return;
     }   
     else if(file.projectDocumentID ==0 && file.FileManagerID==0 && file.base64){
      FileSaver.saveAs(file.base64, file.fileName);
      return;
     }   
  }

  deleteFileFromUploaded(file) {
    // Modify 2,Delete 3
    // const index = this.UploadedFiles.indexOf(file);
    // if (index >= 0) {
    // this.UploadedFiles.find((item) => item.id == file.id).action = 3;
    // this.UploadedFiles.find((item) => item.id == file.id).isDeleted = true;           
    // }
    
    const index = this.UploadedFiles.indexOf(file);
    if (index >= 0) {
      this.UploadedFiles.splice(index, 1);
    }
    this.UploadedNewFiles = this.UploadedFiles;
    // if (this.UploadedFiles.length == 0) {
    //   this.stateCtrl.reset();
    //   this.showAddButton = false;
    // }

   // this.UploadedNewFiles = this.UploadedFiles.filter(x => x.action !=3);

    if(this.UploadedNewFiles.length > 0) {
       this.ShowSubmitButton = true;      
    } else {
      this.ShowSubmitButton = false;     
    }   
  }

  openDialogWithRef(templateRef: TemplateRef<any>, file) {
    let group = {};
    this.formDialog = new FormGroup(group);
    this.formDialog.addControl('filename', this.formBuilder.control(''));
    this.editfilename.id = file.id;
    this.editfilename.filename = file.fileName;
    this.dialog.open(templateRef, {
      panelClass: 'selectParticipants',
    });
  }

  UpdateFileName() {
    // Modify 2,Delete ,3
    let file = this.editfilename;
    this.UploadedFiles;
    this.UploadedFiles.find((item) => item.id == file.id).fileName = file.filename;
    this.UploadedFiles.find((item) => item.id == file.id).action = 2;
   // this.ShowNextButton=true;
    this.close();
  }

  close() {
    this.formDialog.reset();
    this.dialog.closeAll();   
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.UploadedFiles,event.previousIndex, event.currentIndex);    
  }

  sendToken() {     
    
    if(this.isEmailVerified==false){
      this.toastr.warning('Please provide valid email id.', '', {
        timeOut: 3000,
      });
      return;
    }
    if(this.showMobile==true){
      if(this.authenticationMobile==""){
        this.toastr.warning('Please provide valid mobile no.', '', {
          timeOut: 3000,
        });
        return;
      }
    }

    if(this.showMobile==false){
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var check = re.test(String(this.authenticationEmail).toLowerCase());
      if (check == true) {
        this.showEmail=false;
        this.showMobile=false;
        this.showAuthenticationType=false;
        this.tokenPanel=true;
        this.isEmailVerified = false;
        this.sendSubmitButton=true;
        this.otpcodeInput = true;
        this.Mobilesendtoken=false;
        this.showTimeRemaining=true;
        this.timer(1);

        let ReqModel = {
          email: this.authenticationEmail,
          organizationID: Number(this.organizationId),
          officeID: Number(this.myOfficeID),
        }
        this.formsService.GetExterURLToken(ReqModel).subscribe((response) => {    
          if (response != undefined) {
            if (response.status == this.statusConstant.statusSuccess && response.data != null) { 
              this.isEmailVerified = true;             
              this.verifyToken = response.data;             
            }
            this.loaderService.hide();
          } else {
            this.loaderService.hide();
          }
        });
      } else {
        this.toastr.warning('Please provide valid email.', '', {
          timeOut: 3000,
        });
        return;
      }
    }

   

    if(this.showMobile==true){
  
      if (this.authenticationMobile != '') {
        this.showEmail=false;
        this.showMobile=false;
        this.showAuthenticationType=false;
        this.tokenPanel=true;
        this.sendSubmitButton=true;
        this.otpcodeInput = true;
        this.showTimeRemaining=true;
        this.Mobilesendtoken=true;
        this.timer(1);

        let ReqModel = {
          mobileNo: this.authenticationMobile,
          organizationID: Number(this.organizationId),
          officeID: Number(this.myOfficeID),
        }
        this.formsService.GetExterURLToken(ReqModel).subscribe((response) => {    
          if (response != undefined) {
            if (response.status == this.statusConstant.statusSuccess && response.data != null) {              
              this.verifyToken = response.data;             
            }
            this.loaderService.hide();
          } else {
            this.loaderService.hide();
          }
        });
      } else {
        this.toastr.warning('Please provide valid mobile no.', '', {
          timeOut: 3000,
        });
        return;
      }
    }   
  }


  Authentication(){
    if(this.otpCode==undefined){
      this.toastr.error('OTP mismatched', '', {
        timeOut: 3000,
      });
      return;
    }
    if(this.verifyToken==undefined){
      this.toastr.error('OTP mismatched', '', {
        timeOut: 3000,
      });
      return;
    }
      if (this.otpCode == this.verifyToken) {
        this.toastr.success('User verified successfully', '', {
          timeOut: 3000,
        });      
        this.participantEmailId = this.authenticationEmail;
        this.SubmitBy = this.authenticationEmail;
        this.dialog.closeAll();
      }else{
        this.toastr.error('OTP mismatched', '', {
          timeOut: 3000,
        });
      }

  }

  resendOTP(){
    if(this.Mobilesendtoken==false){
      let ReqModel = {
        email: this.authenticationEmail,
        organizationID: Number(this.organizationId),
        officeID: Number(this.myOfficeID),
      }
      this.formsService.GetExterURLToken(ReqModel).subscribe((response) => {
        if (response != undefined) {
          if (response.status == this.statusConstant.statusSuccess && response.data != null) {
            this.isEmailVerified = true;
            this.verifyToken = response.data;
          }
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      });
    }
    if(this.Mobilesendtoken==true){
      let ReqModel = {
        mobileNo: this.authenticationMobile,
        organizationID: Number(this.organizationId),
        officeID: Number(this.myOfficeID),
      }
      this.formsService.GetExterURLToken(ReqModel).subscribe((response) => {
        if (response != undefined) {
          if (response.status == this.statusConstant.statusSuccess && response.data != null) {
            this.isEmailVerified = true;
            this.verifyToken = response.data;
          }
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      });
    }
  }

  
  SubmitDocument() {
    this.dialog.closeAll();
    this.loaderService.show();

    this.formData = new FormData();  
    for (let i = 0; i < this.UploadedFiles.length; i++) {     
      if (this.UploadedFiles[i].file.name.split('.')[0].length > 120) {
        this.toastr.warning('File name upto 120 characters only supported, please rename file.', '', {
          timeOut: 3000,
        });     
        return;
      } 
      var documenttype="";
      var documentName="";
      var FullPath = this.UploadedFiles[i].file.name;
      var documentNameSplit = FullPath.split('.');
      documentName = documentNameSplit[0];
      documenttype = documentNameSplit[1];            
              
      this.formData.append('files', this.UploadedFiles[i].file);
      this.formData.append('FileDetailList', documentName + '|' + documenttype);
    }  
    this.formData.append("ParentID",this.fileMangerFolderId.toString());
    this.formData.append('UserID', this.userID);
    this.formData.append('OrganizationID', this.organizationId);
    this.formData.append('OfficeID', this.myOfficeID);
    this.formData.append('UploadByEmail', this.authenticationEmail);    
    //this.formData.append('DatabaseID', this.databaseId);
    this.spinner=true;
    this.formsService.addFilemanagerFile(this.formData).subscribe(response=>{
     if(response!=undefined){
          var responseHolder = response;
           this.loaderService.hide();
           this.spinner=false;
           if(responseHolder.data == true && responseHolder.status == this.statusConstant.statusSuccess) { 
            this.spinner=false;
            this.loaderService.hide();           
             this.toastr.success('File uploaded successfully.', '', {
               timeOut: 3000,
               });   
               this.dialog.closeAll();       
               this.router.navigate(['/request/fileManagerthanks']);  
             }
            if(responseHolder.data == 2 && responseHolder.status == this.statusConstant.statusSuccess) {
              this.spinner=false;
              this.loaderService.hide(); 
              this.toastr.warning('File already exist.', '', {
                timeOut: 3000,
               });
            }
        }else{
          this.spinner=false;
          this.loaderService.hide(); 
        }
      });
  
    }

    showEmail:boolean=true;
    showMobile:boolean=false;
    sendTokenButton:boolean=false;
    sendSubmitButton:boolean=false;
    tokenotpCode:boolean=false;
    showAuthenticationType=true;
    showTimeRemaining:boolean=false;
    otpcodeInput:boolean=false;
    Mobilesendtoken: boolean = false;
    tokenPanel:boolean=false;

    getTokenEmail(value: MatRadioChange) {
      this.showEmail=true;
      this.showMobile=false;
      
      this.sendTokenButton=false;
    }

    getTokenMobile(value: MatRadioChange) {
      this.showEmail=true;
      this.showMobile=true;

      this.sendTokenButton=false;
    }


    display: any;
    interval: any;

    timer(minute) {
      // let minute = 1;
      let seconds: number = minute * 30;
      let textSec: any = "0";
      let statSec: number = 30;
  
      const prefix = minute < 10 ? "0" : "";
  
      this.interval = setInterval(() => {

       // let currentUser = sessionStorage.getItem('userToken');
       // if (currentUser != null && currentUser != undefined && currentUser != "") 
       {
          seconds--;
          if (statSec != 0) statSec--;
          else statSec = 30;
    
          if (statSec < 10) {
            textSec = "0" + statSec;
          } else textSec = statSec;
    
          this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
    
          if (seconds == 0) {     
            this.showTimeRemaining=false;   
            this.tokenotpCode=true;     
            clearInterval(this.interval);
          }
        }
        // else{         
        //  // clearInterval(this.interval);
        // }
      
      }, 1000);
    }

    getEmailVerified() {
      let emailVerified: boolean;
      const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      emailVerified = regexp.test(this.authenticationEmail);
      this.isEmailVerified = emailVerified;
    }

}
